import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config/config';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userToken, setUserToken] = useState(null);
  const [userId, setUserId] = useState(null);

  // Function to log in and store token/userId
  const loginContext = async (email, password) => {
    try {
      const response = await axios.post(`${config.API_BASE_URL}/api/auth/login`, { email, password });

      if (response.data && response.data.token && response.data.userId) {
        const { token, userId } = response.data;

        // Save token & userId in state
        setUserToken(token);
        setUserId(userId);

        localStorage.setItem('userToken', token);
        localStorage.setItem('userId', userId);

        console.log('Login successful. Token saved:', token);
      } else {
        console.log('Login failed. No token received.');
        throw new Error('Invalid credentials');
      }
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  // Function to log out user
  const logoutContext = () => {
    setUserToken(null);
    setUserId(null);
    localStorage.removeItem('userToken');
    localStorage.removeItem('userId');
    console.log('User logged out.');
  };

  // Function to check if user is already authenticated
  const checkAuthStatus = () => {
    const token = localStorage.getItem('userToken');
    const id = localStorage.getItem('userId');

    if (token && id) {
      setUserToken(token);
      setUserId(id);
      console.log('User is authenticated. Token:', token);
    } else {
      console.log('No user session found.');
    }
  };

  useEffect(() => {
    checkAuthStatus();
  }, []);

  return (
    <AuthContext.Provider value={{ userToken, userId, loginContext, logoutContext }}>
      {children}
    </AuthContext.Provider>
  );
};
